import * as React from "react"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import TextField from "@mui/material/TextField"
import CloseIcon from '@mui/icons-material/Close';
import { AXIOS_API_INSTANCE, SERVICE_ORDER_CUSTOMER_APPROVAL_FRIENDLY_NAMES } from "../../../Constants"
import { send_authorized_request } from "../../../Constants/cognito"
import { useSnackbar } from 'notistack';
import { Box, FormControl, FormControlLabel, FormLabel, IconButton, Radio, RadioGroup } from "@mui/material"
import Grid from "@mui/material/Grid2"
import { LoadingBackdropIndeterminate } from "../../LoadingBackdrop"

export default function ChangeCustomerApprovalStatusModal({
    serviceOrder,
    serviceOrderService = undefined,
    open,
    closeModal,
}) {
    const { enqueueSnackbar } = useSnackbar();
    const [status, setStatus] = React.useState('NOT_REQUESTED')
    const [notes, setNotes] = React.useState("")
    const [saving, setSaving] = React.useState(false)
    const statuses = [
        'NOT_REQUESTED',
        'APPROVAL_REQUESTED',
        'APPROVED',
        'DECLINED',
    ]

    React.useEffect(() => {
        setStatus(serviceOrderService?.customer_approved_status ?? serviceOrder.customer_approved_status)
        setNotes("")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])

    const save = (event) => {
        setSaving(true)
        const new_status = {
            status: status,
            serviceorderservice_id: serviceOrderService?.id,
            notes: notes.trim()
        }
        send_authorized_request(() =>
            AXIOS_API_INSTANCE.post(`serviceorders/${serviceOrder.id}/change_service_customer_approval_status`, new_status).then((serviceOrder) => {
                setSaving(false)
                enqueueSnackbar('Successfully changed status', { variant: 'success' })
                closeModal(serviceOrder.data.data)
            }).catch((error) => {
                setSaving(false)
                enqueueSnackbar(`Failed to change status <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
            })
        )
    }

    return (
        (<div>
            <Dialog
                open={open}
                onClose={() => closeModal(false)}
                maxWidth={'lg'}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <LoadingBackdropIndeterminate
                    open={saving}
                    text={"Updating Customer Approval"}
                />
                <DialogTitle>
                    <span style={{ "paddingRight": "24px" }}>Change Customer Approval Status</span>
                    <IconButton
                        aria-label="close"
                        onClick={() => closeModal(false)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Box>
                        <Grid container direction="column" spacing={2} sx={{ minWidth: '300px' }}>
                            <Grid size="grow">
                                <FormControl>
                                    <FormLabel id="radio-buttons-group-label">New Status</FormLabel>
                                    <RadioGroup
                                        aria-labelledby="radio-buttons-group-label"
                                        name="radio-buttons-group"
                                        value={status}
                                        onChange={(event) => setStatus(event.target.value)}
                                    >
                                        {statuses.map((status) =>
                                            <FormControlLabel key={status} value={status} disabled={status === (serviceOrderService?.customer_approved_status ?? serviceOrder.customer_approved_status)} control={<Radio />} label={SERVICE_ORDER_CUSTOMER_APPROVAL_FRIENDLY_NAMES[status]} />
                                        )}
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid size="grow">
                                <TextField
                                    margin="dense"
                                    id="changestatusnote"
                                    label="Notes (optional)"
                                    type="text"
                                    fullWidth
                                    variant="filled"
                                    multiline
                                    minRows={2}
                                    value={notes}
                                    onChange={(event) => setNotes(event.target.value)}
                                    sx={{ mt: 0 }}
                                    slotProps={{
                                        input: { maxLength: 2055 }
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Grid container justifyContent="space-between" sx={{ padding: "0px 30px 10px 30px", width: '100%' }}>
                        <Grid size="auto">
                        </Grid>
                        <Grid size="auto">
                            <Button variant="contained" autoFocus onClick={save}>
                                Update
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </div>)
    );
}
